import type React from "react";
import { useEffect, useState } from "react";
import denied from "../../../shared/media/denied.mp3";
import notification from "../../../shared/media/notification.wav";
import slide from "../../../shared/media/slide.wav";
import { Card } from "./Card";
import "./MemoryCardsGame.scss";
import lodash from "lodash";
import { Button, Tag } from "rsuite";

type Props = {
	data: { value: string; pic: string }[];
};

export const MemoryCardGame: React.FC<Props> = ({ data }) => {
	const [cards, setCards] = useState<
		{
			value: string;
			pic: string;
			turned: boolean;
			matched: boolean;
			index: number;
			gameStarted: boolean;
		}[]
	>([]);
	const [pairs, setPairs] = useState<string[]>([]);
	const [clicks, setClicks] = useState(0);
	const [memoryGameStarted, setGameStart] = useState(false);

	useEffect(() => {
		const arr = data.map(
			(item: { value: string; pic: string }, index: number) => ({
				value: item.value,
				pic: item.pic,
				turned: false,
				matched: false,
				index,
				gameStarted: false,
			}),
		);
		setCards(lodash.shuffle(arr));
	}, [data]);

	useEffect(() => {
		if (pairs.length === 2) {
			if (pairs[0] === pairs[1]) {
				const newCards = [...cards];
				for (const card of newCards) {
					if (card.value === pairs[0]) {
						card.matched = true;
						setTimeout(() => {
							const sound = new Audio(notification);
							sound.play();
						}, 500);
					}
				}
				setCards(newCards);
				setPairs([]);
			} else {
				setTimeout(() => {
					const newCards = [...cards];
					for (const card of newCards) {
						if (card.value === pairs[0] || card.value === pairs[1]) {
							card.turned = false;
						}
					}
					setPairs([]);
					setCards(newCards);
					const sound = new Audio(denied);
					sound.play();
				}, 1000);
			}
		}
	}, [pairs, cards]);

	const handleCardClick = (
		card: {
			value: string;
			pic: string;
			turned: boolean;
			matched: boolean;
			index: number;
			gameStarted: boolean;
		},
		index: number,
	) => {
		if (pairs.length < 2) {
			const newCards = [...cards];
			if (!newCards[index].turned) {
				const sound = new Audio(slide);
				sound.play();
				newCards[index].turned = true;
				setClicks(clicks + 1);
				setCards(newCards);
				setPairs([...pairs, card.value]);
			}
		}
	};

	return (
		<div>
			<div className="memory-game-info-container">
				<div className="memory-game-info">
					<Button
						appearance="primary"
						size="lg"
						color="green"
						onClick={() => {
							setGameStart(true);
						}}
					>
						start game
					</Button>
				</div>
				<Tag size="lg" color="green">
					Flips {clicks}
				</Tag>
			</div>
			<div className="memory-game-container">
				{cards?.map((card, index) => (
					<div
						key={card.value}
						onClick={() => {
							if (memoryGameStarted) {
								handleCardClick(card, index);
							} else {
								alert("please start the game");
							}
						}}
						onKeyUp={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								if (memoryGameStarted) {
									handleCardClick(card, index);
								} else {
									alert("please start the game");
								}
							}
						}}
					>
						<Card key={card.value} item={card} id={index} />
					</div>
				))}
			</div>
		</div>
	);
};
